
         

export function createXLSheetdata(attritionList) {
    attritionList.find((ticketDetails, index) => {                


                delete attritionList[index]['id']

                attritionList[index].EmployeeCode=attritionList[index].employee_code
                delete attritionList[index]['employee_code']


                attritionList[index].EmployeeName=attritionList[index].employee_name                
                delete attritionList[index]['employee_name']

                attritionList[index].FromKitchen=attritionList[index].from_kitchen
                delete attritionList[index]['from_kitchen']
                attritionList[index].FromKitchenCode=attritionList[index].from_kitchen_code
                delete attritionList[index]['from_kitchen_code']
                delete attritionList[index]['from_kitchen_manager_id']
                delete attritionList[index]['from_kitchen_cluster_manager_id']

                attritionList[index].toKitchen=attritionList[index].to_kitchen
                delete attritionList[index]['to_kitchen']

                attritionList[index].toKitchenCode=attritionList[index].to_kitchen_code
                delete attritionList[index]['to_kitchen_code']
                delete attritionList[index]['to_kitchen_manager_id']
                delete attritionList[index]['to_kitchen_cluster_manager_id']
                delete attritionList[index]['to_kitchen_city_manager_id']


                attritionList[index].MovementReason=attritionList[index].movement_reason
                delete attritionList[index]['movement_reason']

                attritionList[index].MovementRemarks=attritionList[index].movement_remarks
                delete attritionList[index]['movement_remarks']

                attritionList[index].MovedOn=attritionList[index].moved_on
                delete attritionList[index]['moved_on']


                attritionList[index].MovmentStatus=attritionList[index].status
                delete attritionList[index]['status']
                

                attritionList[index].StatusReason=attritionList[index].status_reason
                delete attritionList[index]['status_reason']

                attritionList[index].StatusRemarks=attritionList[index].status_remarks
                delete attritionList[index]['status_remarks']


                attritionList[index].ApprovedBy=attritionList[index].approver
                delete attritionList[index]['approver']

                attritionList[index].City=attritionList[index].employee_city_name
                delete attritionList[index]['employee_city_name']

                attritionList[index].ManagerReason=attritionList[index].manager_reason_name
                delete attritionList[index]['manager_reason_name']

                attritionList[index].ManagerRemarks=attritionList[index].manager_remarks
                delete attritionList[index]['manager_remarks']


                attritionList[index].CreatedOn=attritionList[index].created_on
                delete attritionList[index]['created_on']
                

                attritionList[index].CreatedBy=attritionList[index].created_by
                delete attritionList[index]['created_by']

                attritionList[index].ModifiedOn=attritionList[index].modified_on
                delete attritionList[index]['modified_on']



                attritionList[index].ModifiedBy=attritionList[index].modified_by
                delete attritionList[index]['modified_by']


                delete attritionList[index]['editAccess']
            
                return false
            })   
            return attritionList
}



// WEBPACK FOOTER //
// ./src/modules/Employees Movement/services/helpers.js